import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'sort' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/sort.js.map
